export const cardTokens = {
  shell:
    'rounded-2xl border border-gray-100 dark:border-gray-700 bg-white dark:bg-gray-800 shadow-card dark:shadow-card-dark',
  shellHover:
    'hover:shadow-card-hover dark:hover:shadow-card-hover-dark transition-shadow duration-200',
  pad: 'p-4 md:p-5',
  padCompact: 'p-3 md:p-4',
};
